module.exports = __webpack_public_path__ + "static/img/solutions-3.485879d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/solutions-3.jpeg
// module id = OJVy
// module chunks = 1